type LogLevel = 'log' | 'warn' | 'error' | 'info' | 'debug' | 'count'

class Logger {
  private isDev = import.meta.env.DEV

  private createLogMethod(level: LogLevel) {
    return (...args: any[]) => {
      if (this.isDev) {
        console[level](...args)
      }
    }
  }

  log = this.createLogMethod('log')
  warn = this.createLogMethod('warn')
  error = this.createLogMethod('error')
  info = this.createLogMethod('info')
  debug = this.createLogMethod('debug')
  count = this.createLogMethod('count')
}

export const logger = new Logger()
